











































import RegistrationModule, { RegistrationStatus } from '@/store/modules/registration.module';
import AuthModule from '@/store/modules/auth.module';
import Component from 'vue-class-component';
import { EmptyRegistration } from '@/models/registration';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';

@Component({})
export default class AccountCreateSuccessView extends Vue {
  private registrationModule = getModule(RegistrationModule, this.$store);
  private authModule = getModule(AuthModule, this.$store);

  get email() {
    return this.registrationModule.registration.userId;
  }

  mounted() {
    if (this.registrationModule.status !== RegistrationStatus.Succeeded
      || this.registrationModule.registration === EmptyRegistration) {
      this.$router.push('/create-account');
    }
  }

  signIn() {
    this.authModule.login({ redirectPath: '/main' });
  }
}
